import { CommonModule } from '@angular/common'
import { Component, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent } from '../../shared'
import { PurchasedMaterialFilters } from './purchased-material-filters'
import { PurchasedMaterialsItemsComponent } from './purchased-materials-items.component'
import { PurchasedMaterialsOverviewComponent } from './purchased-materials-overview.component'
import { PurchasedMaterialsPricesComponent } from './purchased-materials-prices.component'
import { PurchasedMaterialsSimilarComponent } from './purchased-materials-similar.component'
import { PurchasedMaterialsVendorsComponent } from './purchased-materials-vendors.component'
import { PurchasedMaterialsVistaVendorsComponent } from './purchased-materials-vista-vendors.component'
import { PurchasedMaterialsJobsComponent } from './purchased-materials-jobs.component'
import { PurchasedMaterialsEquipmentComponent } from './purchased-materials-equipment.component'
import { PurchasedMaterialsQualityComponent } from './purchased-materials-quality.component'

@Component({
    templateUrl: './purchased-materials.component.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        WjInputModule,
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        PurchasedMaterialsOverviewComponent,
        PurchasedMaterialsItemsComponent,
        PurchasedMaterialsPricesComponent,
        PurchasedMaterialsSimilarComponent,
        PurchasedMaterialsVendorsComponent,
        PurchasedMaterialsVistaVendorsComponent,
        PurchasedMaterialsJobsComponent,
        PurchasedMaterialsEquipmentComponent,
        PurchasedMaterialsQualityComponent,
    ],
})
export class PurchasedMaterialsComponent extends BaseComponent {
    activeTab = 1
    startDate: Date
    endDate: Date
    category = 'material'
    search = ''
    categories = ['material', 'service', 'rental', 'freight', 'labor', 'fee', 'other', 'tax']
    filters = signal<PurchasedMaterialFilters>(this.emptyFilters())
    priceDescription = signal('')

    constructor() {
        super()
        const today = new Date()
        this.endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        this.startDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate())
        this.filters.set(this.currentFilters())
        this.initialLoadingComplete()
    }

    refresh() {
        this.filters.set(this.currentFilters())
    }

    mergeCategories(names: string[]) {
        this.categories = Array.from(new Set([...this.categories, ...names])).sort()
    }

    tabChanged() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    showPriceHistory(description: string) {
        this.priceDescription.set(description)
        this.activeTab = 3
    }

    isTab(tab: number) {
        return Number(this.activeTab) === tab
    }

    private currentFilters(): PurchasedMaterialFilters {
        return {
            startDate: this.toDateOnly(this.startDate),
            endDate: this.toDateOnly(this.endDate),
            category: this.category,
            search: (this.search ?? '').trim(),
        }
    }

    private emptyFilters(): PurchasedMaterialFilters {
        return { startDate: '', endDate: '', category: 'material', search: '' }
    }

    private toDateOnly(value: Date): string {
        const year = value.getFullYear()
        const month = String(value.getMonth() + 1).padStart(2, '0')
        const day = String(value.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }
}
